import { TriggerStrategyType, TriggerStrategyTypeUnion } from "types/campaigns";

export const formatTriggerStrategy = (trigger: TriggerStrategyTypeUnion) => {
  switch (trigger) {
    case TriggerStrategyType.DAILY:
    case TriggerStrategyType.WEEKLY:
    case TriggerStrategyType.MONTHLY:
      return trigger;
    case TriggerStrategyType.BIRTHDAY:
      return "membersBirthday";
    case TriggerStrategyType.REGISTRATION_ANNIVERSARY:
      return "membershipAnniversary";
  }
};
